import { CloseIcon } from '@chakra-ui/icons';
import {
    Alert,
    AlertDescription,
    AlertDescriptionProps,
    AlertIcon,
    AlertProps,
    AlertTitle,
    AlertTitleProps,
    BoxProps,
    ListItem,
    UnorderedList
} from '@chakra-ui/react';
import { useCallback } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';

export type ApiErrorMessage = {
    code: string;
    field: string;
    location: string;
};

export type ApiErrorProps = {
    title?: string;
    errors?: ApiErrorMessage[];
    alertProps?: AlertProps;
    alertTitleProps?: AlertTitleProps;
    alertDescriptionProps?: AlertDescriptionProps;
};

export const ApiErrors = (props: ApiErrorProps & BoxProps) => {
    const { title, errors, ...rest } = props;
    const intl = useIntl();
    const alertTitle = title || intl.formatMessage({ id: 'api.errors.title' });

    const errorElement = useCallback(
        (error: ApiErrorMessage) => (
            <ListItem key={error.code}>
                <FormattedMessage
                    id={`validation.${error.code}`}
                    defaultMessage={`validation.${error.code}`}
                />
            </ListItem>
        ),
        []
    );

    const errorItems = errors?.map((item) => errorElement(item));

    if (!errors?.length) {
        return <></>;
    }

    return (
        <Alert
            display="block"
            status="error"
            bgColor="#FFF5F5"
            borderRadius={35}
            {...props.alertProps}
            py={5}
            px={6}
            {...rest}
        >
            <AlertTitle display="flex" alignItems="center" fontSize="lg" mb={4}>
                <AlertIcon
                    display="flex"
                    alignItems="center"
                    bgColor="#E95E5F"
                    p="6px"
                    w={6}
                    h={6}
                    borderRadius="full"
                    fontSize="xs"
                >
                    <CloseIcon fontWeight="bold" color="white" w={3} h={3} />
                </AlertIcon>
                {alertTitle}
            </AlertTitle>
            <AlertDescription>
                <UnorderedList display="grid" gridRowGap={1}>
                    {errorItems}
                </UnorderedList>
            </AlertDescription>
        </Alert>
    );
};
